module.exports = __webpack_public_path__ + "static/media/mail-icon.72d97ee7.svg";